import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox, SelectTag } from '../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography ,Box,  TextField as MuiTextField} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { SHIFT_TYPE } from '../../../../../constants';

const initialShiftDataObj = {
  data: [],
  loading: false
};

const TABLE_COLUMNS = [
    {
      header: 'Shift',
      accessor: (row) => {
        const status = row.status;
        return (
          <span
            style={{
              color: status === 'inactive' ? 'red' : 'black',
            }}
          >
            {`${row.shiftName}`}
          </span>
        );
      },
    },
    {
      header: 'Status',
      accessor: 'status',
      sx: { textTransform: 'uppercase' }
    },
    {
      header: 'Created At',
      accessor: 'createdAt'
    }
  ];

export const ShiftMaster = ({getShiftDropdown, setShiftMasterDialogue}) => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [shiftDataObj, setShiftDataObj] = useState(initialShiftDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [input,setInput] = useState('')

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        shiftName: Yup.string().required('Role is required')
      })
    ),
    defaultValues: { name: '' },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const formatTime = (date) => {
        const d = new Date(date);
        const hours = d.getHours().toString().padStart(2, '0'); // Ensure 2-digit format
        const minutes = d.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;  // Format as HH:mm
      };
  
      setValue('shiftName', selectedRecord?.shiftName);
      setValue('startTime', formatTime(selectedRecord?.startTime));
      setValue('endTime', formatTime(selectedRecord?.endTime));
      setValue('shiftType', selectedRecord?.shiftType);
      setValue('description', selectedRecord?.description);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);
  
  
  

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/employee-shift-update' : '/employee-shift-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        shiftName: formValues.shiftName,
      startTime: formValues.startTime,
      endTime:formValues.endTime,
      shiftType:formValues.shiftType,
      description:formValues.description
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Shift master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      getShiftDropdown()
      setShiftMasterDialogue(false)
      handleShiftList()
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Shift master`, { variant: 'error' });
    }
    setLoading(false);
  };


  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/employee-shift-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully CancelLed Shift master', { variant: 'success' });
      setSelectedRecord();
      handleShiftList()
    } else {
      toast('Failed to Cancelled Shift master', { variant: 'error' });
    }
    setLoading(false);
  };


  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/employee-shift-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Shift master', { variant: 'success' });
      setSelectedRecord();
      handleShiftList()
    } else {
      toast('Failed to delete Shift master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleShiftList= async () => {
    setOpenQueryDialog(true);
    setShiftDataObj({ loading: true });
    const response = await request('/employee-shift-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(item =>
        item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setShiftDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setShiftDataObj({ loading: false });
    }
  };

  useEffect(()=>{
    handleShiftList()
  },[])

  console.log(shiftDataObj,"HELLO SHIFT DATA OBJ")

  const handleChange=()=>{

  }
  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',

          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
              Shift Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord()
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={"Exit"}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Stack spacing={2} sx={{ marginBottom: "1%" }}>
            <Box sx={{ border: '1px solid gray', padding: 2, borderRadius: '8px',width: '100%' ,boxShadow: '0px 2px 10px #0099ff' }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Shift Name</Typography>
                <TextField
                  name="shiftName"
                  sx={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  inputProps={{ sx: { fontSize: '1.6rem' } }}
                  placeholder="Enter Shift Name"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Start Time</Typography>
                <TextField
                  name="startTime"
                  sx={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  inputProps={{ sx: { fontSize: '1.6rem' } }}
                  type="time"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>End Time</Typography>
                <TextField
                  name="endTime"
                  sx={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  inputProps={{ sx: { fontSize: '1.6rem' } }}
                  type="time"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Shift Type</Typography>
                <SelectTag
                  name="shiftType"
                  formControlSX={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  fullWidth
                  menus={SHIFT_TYPE}
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Description</Typography>
                <TextField
                  name="description"
                  sx={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  inputProps={{ sx: { fontSize: '1.6rem' } }}
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
          marginTop="2%"
        >
          <Typography variant="h5" fontWeight="bold">
            Shift Master List
          </Typography>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={shiftDataObj.data || []}
          loading={shiftDataObj.loading}
          onRowClick={(row) => {
            setOpenQueryDialog(false);
            setSelectedRecord(row);
          }}
        />
              </Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
